/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import * as Examples from './Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    a: "a",
    strong: "strong",
    pre: "pre"
  }, _provideComponents(), props.components);
  if (!Examples) _missingMdxReference("Examples", false);
  if (!Examples.WithHeadingsAndAriaLabel) _missingMdxReference("Examples.WithHeadingsAndAriaLabel", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Description"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "Card"
      }), " is a block section element showing the white box with rounded gray borders, adding spacing automatically."]
    }), "\n", _jsxs(_components.p, {
      children: ["It uses ", _jsx(_components.a, {
        href: "/uilib/layout/flex/item",
        children: "Flex.Item"
      }), " under the hood. When one of these props were given, ", _jsx(_components.code, {
        children: "stack"
      }), ", ", _jsx(_components.code, {
        children: "direction"
      }), " or ", _jsx(_components.code, {
        children: "spacing"
      }), " – the ", _jsx(_components.a, {
        href: "/uilib/layout/flex/container",
        children: "Flex.Container"
      }), " will be used."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "BETA:"
      }), " The design is not 100% finalised and may change to be officially approved by UX through an RFC."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "import { Card } from '@dnb/eufemia'\nimport { Form, Field } from '@dnb/eufemia/extensions/forms'\n\nrender(\n  <Form.Handler data={existingData} onSubmit={submitHandler}>\n    <Card>\n      <Field.Email path=\"/dataPath\" />\n      <Form.ButtonRow>\n        <Form.SubmitButton />\n      </Form.ButtonRow>\n    </Card>\n  </Form.Handler>,\n)\n"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Accessibility"
    }), "\n", _jsxs(_components.p, {
      children: ["It uses a ", _jsx(_components.code, {
        children: "section"
      }), " element. Which allows you to add an ", _jsx(_components.code, {
        children: "aria-label"
      }), " or ", _jsx(_components.code, {
        children: "aria-labelledby"
      }), " to provide screen readers with landmarks."]
    }), "\n", _jsx(Examples.WithHeadingsAndAriaLabel, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
